import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/lang'
import enRoutes from './lang/English.js'
import chRoutes from './lang/Chinese.js'
import store from '@/store/'
Vue.use(VueRouter)
const routes = [
    ...enRoutes,
    ...chRoutes,
    // {
    //     path: "*",
    //     redirect: "/english/home",
    // },
    // {
    //     path: "/",
    //     redirect: "/english/home",
    // },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})
const routerList = [
    // {
    //     path: '*',
    //     redirect: i18n.locale === 'english' ? `/super-yacht-rental-dubai` : `/${i18n.locale}/super-yacht-rental-dubai`,
    // },
    {
        path: '/',
        redirect: i18n.locale === 'english' ? `/super-yacht-rental-dubai` : `/${i18n.locale}/super-yacht-rental-dubai`,
    },
    {
        path: '*',
        component: () => import('@/views/error/404'),
    },
]
router.addRoutes(routerList)
// 导航守卫
router.beforeEach((to, from, next) => {
    // 每次路由跳转之后到回到顶部
    document.body.scrollTop = 0
    // firefox浏览器
    document.documentElement.scrollTop = 0
    
    if (to.path.indexOf('chinese') != -1) {
        if (i18n.locale !== 'chinese') {
            i18n.locale = 'chinese'
            localStorage.setItem('languageSet', i18n.locale)
        }
    } else {
        if (i18n.locale !== 'english') {
            i18n.locale = 'english'
            localStorage.setItem('languageSet', i18n.locale)
        }
    }
    store.dispatch('baseConfig/getBaseConfigInfo')
    // 判断游艇id是否存在
    // 未登录
    if (store.state.login.token === '') {
        // 已登录去登录页跳转到首页
        if (to.path.indexOf('OrderManagement') != -1) {
            next(`/${i18n.locale}/home`)
        } else {
            next()
        }
    } else {
        if (store.state.login.loginInfo.userType == 0) {
            if (to.path.indexOf('QuickOrder') != -1) {
                next(`/${i18n.locale}/OrderManagement/Management`)
            } else {
                next()
            }
        } else {
            next()
        }
    }
})

export default router
